"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  'cdnBaseUrl': 'https://cdn.elluciancloud.com/assets/EDS2/',
  'appVersion': '6.7.0'
};
exports.default = _default;